import React from "react";
import InnerLayout, { disclosureSidebar } from "../InnerLayout";

const iqacObjectives = [
  "The Primary aim of the IQAC is to develop a system for conscious, consistent and catalytic action to improve the academic and administrative performance of the College",
  "The IQAC will provide greater clarity and focus in institutional functioning towards quality enhancement and facilitate internalization of the quality culture.",
  "The IQAC will contribute towards enhancement and integration among the activities of the College and institutionalize many good practices.",
  // "Institutionalization of best practices",
  // "Monitoring academic and administrative performance",
  // "Facilitating accreditation and ranking activities",
];

const iqacDocuments = [
  { title: "IQAC MoM 2024-25", file: "/IQAC_MoM/IQAC-MOM-2024-25.pdf" },
  { title: "IQAC MoM 2023-24", file: "/IQAC_MoM/IQAC-MOM-2023-24.pdf" },
  { title: "IQAC MoM 2022-23", file: "/IQAC_MoM/IQAC-MoM-2022-23.pdf" },
  {
    title: "IQAC MoM 2021-22 Even",
    file: "/IQAC_MoM/IQAC-MoM-2021-22-Even.pdf",
  },
  {
    title: "IQAC MoM 2021-22 Odd",
    file: "/IQAC_MoM/IQAC-MoM-2021-22-Odd.pdf",
  },
  {
    title: "IQAC MoM 2020-21 Odd",
    file: "/IQAC_MoM/IQAC-MoM-2020-21-Odd.pdf",
  },
];

const iqacCommittee = [
  ["1", "Dr. Vadiraj A. Kulkarni", "Chair Person"],
  ["2", "Shri. Prashant Kulkarni", "Management Nominee"],
  ["3", "Shri. Narayan Tosur", "Member"],
  ["4", "Prof. Laxmi G Hattiholi", "IQAC Co-Ordinator"],
  ["5", "Prof. Majunatha", "Member"],
  ["6", "Dr. Gururaj Hatti", "Member"],
  ["7", "Dr. Shailesh Chanpatna", "Member"],
  ["8", "Prof. S D Kulkarni", "Member"],
  ["9", "Dr. K. S. Pujari", "Member"],
  ["10", "Dr. Mahendra Dixit", "Member"],
  ["11", "Dr Venkatesh Shankar", "Member"],
  ["12", "Dr. Sameer M. Galagali", "Member"],
  ["13", "Dr. Poornima Raikar", "Member"],
  ["14", "Dr. Nagaraj Bhat", "Member"],
  ["15", "Prof. Rajeshwari N.", "Member"],
  ["16", "Prof. Harsha Jadhav", "Member"],
  ["17", "Prof. Naveen Hiremath", "Member"],
  ["18", "Prof. Varaprasad Gaonkar", "Registrar"],
  ["19", "Mrs. Radha Rani Mahadev Kolambe","Local Society (Child Welfare Committee Member - Karwar)",],
  ["20", "Mr. Madiwalappa Anapati", "Alumni"],
  ["21", "Ms. Rakshita Vaidya", "Student"],
  ["22", "Mr. Abhishek Galatgi", "Student"],
];
const iqacMechanisms = [
  "Ensuring timely, efficient and progressive performance of academic, administrative and financial tasks",
  "The relevance and quality of academic and research programmes",
  "Equitable access to and affordability of academic programmes for various sections of society",
  "Optimization and integration of modern methods of teaching and learning",
  "The credibility of evaluation procedures",
  "Ensuring the adequacy, maintenance and functioning of the support structure and services",
  "Research sharing and networking with other institutions in India and abroad",
];

const iqacFunctions = [
  "Development and application of quality benchmarks/parameters for various academic and administrative activities of the institution",
  "Facilitating the creation of a learner-centric environment conducive to quality education and faculty maturation to adopt the required knowledge and technology for participatory teaching and learning process",
  "Arrangement for feedback response from students, parents and other stakeholders on quality-related institutional processes",
  "Organization of inter and intra institutional workshops, seminars on quality related themes and promotion of quality circles",
  "Acting as a nodal agency of the Institution for coordinating quality-related activities.",
  "Development of Quality Culture in the institution",
  "Periodical conduct of Academic and Administrative Audit and its follow-up.",
];


const IQAC = () => {
  return (
    <InnerLayout
      title="Internal Quality Assurance Cell (IQAC)"
      image="https://images.pexels.com/photos/12091126/pexels-photo-12091126.jpeg?w=2400"
      breadcrumbs={[
        { label: "Disclosure", to: "/disclosure" },
        { label: "IQAC" },
      ]}
      sidebar={disclosureSidebar}
      sidebarTitle="Disclosure"
    >
      <section id="committee-members" className="mb-14 scroll-mt-32">
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          About IQAC
        </h2>

        <div className="vdit-prose">
          <p>
            The primary aim of IQAC is to develop a system for conscious,
            consistent and catalytic action to improve the academic and
            administrative performance of the institution. It also promotes the
            measures for institutional functioning towards quality enhancement
            through internalization of quality culture and institutionalization
            of best practices.
          </p>

          <p>
            The IQAC serves as a catalyst for quality enhancement and
            institutional excellence by promoting academic quality,
            administrative efficiency, innovation, stakeholder engagement, and
            continuous improvement practices throughout the institution.
          </p>

          <p>
            The cell comprises representatives from management, industry,
            faculty, administration, alumni, and students, ensuring a
            comprehensive approach to quality assurance and institutional
            development.
          </p>
        </div>
      </section>

      <section className="mb-14">
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          IQAC Co-ordinator
        </h2>

        <div className="bg-white border border-brand/10 p-6 flex flex-col sm:flex-row items-start gap-6">
          <img
            src="/IQAC_images/Laxmi_Hattiholi_IQAC.JPG"
            alt="IQAC Co-ordinator Laxmi Hattiholi"
            className="w-40 h-48 object-cover border border-brand/10"
          />

          <div>
            <h3
              className="text-2xl text-brand font-semibold"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Laxmi Hattiholi
            </h3>
            <p className="mt-2 text-[#2a2a2a]/85">IQAC Co-ordinator</p>
          </div>
        </div>
      </section>

      <section className="mb-14">
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Objectives of IQAC
        </h2>

        <div className="grid md:grid-cols-2 gap-4">
          {iqacObjectives.map((objective) => (
            <div
              key={objective}
              className="bg-white border border-brand/10 p-5"
            >
              <p className="text-[#2a2a2a]/85">{objective}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-14">
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Functions of the IQAC
        </h2>

        <div className="grid md:grid-cols-2 gap-4">
          {iqacFunctions.map((item) => (
            <div key={item} className="bg-white border border-brand/10 p-5">
              <p className="text-[#2a2a2a]/85">{item}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-14">
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          IQAC Evolve Mechanisms and Procedures
        </h2>

        <div className="grid md:grid-cols-2 gap-4">
          {iqacMechanisms.map((mechanism) => (
            <div
              key={mechanism}
              className="bg-white border border-brand/10 p-5"
            >
              <p className="text-[#2a2a2a]/85">{mechanism}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-14">
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          IQAC Composition
        </h2>

        <div className="bg-white border border-brand/10 p-6">
          <p className="text-[#2a2a2a]/85 leading-relaxed">
            The IQAC comprises a Chairperson, Management Nominee, Industry
            Representatives, Faculty Members, Administrative Representatives,
            Alumni Representatives, and Student Representatives. This structure
            ensures broad stakeholder participation in institutional quality
            initiatives.
          </p>
        </div>
      </section>

      <section className="mb-14">
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          IQAC Committee Members
        </h2>

        <div className="overflow-hidden border border-brand/10">
          <table className="w-full">
            <thead>
              <tr className="bg-brand text-white">
                <th className="px-5 py-4 text-left">No.</th>
                <th className="px-5 py-4 text-left">Name</th>
                <th className="px-5 py-4 text-left">Designation</th>
              </tr>
            </thead>

            <tbody>
              {iqacCommittee.map(([no, name, designation], index) => (
                <tr
                  key={no}
                  className={index % 2 === 0 ? "bg-white" : "bg-surface-alt/40"}
                >
                  <td className="px-5 py-4">{no}</td>
                  <td className="px-5 py-4">{name}</td>
                  <td className="px-5 py-4">{designation}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section id="mom" className="scroll-mt-32">
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          IQAC Minutes of Meetings (MoM)
        </h2>

        <div className="overflow-hidden border border-brand/10">
          <table className="w-full">
            <thead>
              <tr className="bg-brand text-white">
                <th className="px-5 py-4 text-left">Sl. No.</th>

                <th className="px-5 py-4 text-left">Document</th>

                <th className="px-5 py-4 text-left">Download</th>
              </tr>
            </thead>

            <tbody>
              {iqacDocuments.map((doc, index) => (
                <tr
                  key={doc.title}
                  className={index % 2 === 0 ? "bg-white" : "bg-surface-alt/40"}
                >
                  <td className="px-5 py-4">{index + 1}</td>

                  <td className="px-5 py-4">{doc.title}</td>

                  <td className="px-5 py-4">
                    <a
                      href={doc.file}
                      target="_blank"
                      rel="noreferrer"
                      className="text-brand font-semibold hover:underline"
                    >
                      Download PDF
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-sm text-[#3a3a3a]/70 mt-4">
          * IQAC meeting minutes, action taken reports and quality assurance
          documents are updated periodically.
        </p>
      </section>
    </InnerLayout>
  );
};

export default IQAC;
